import type { JobApi } from '@/modules/jobs/types';

export const canRetryFailedSourcing = (job: JobApi): boolean =>
  job.sourcingState === 'Failed' &&
  job.state !== 'OnHold' &&
  job.state !== 'Hired' &&
  job.state !== 'Closed';

export const canUserRetryFailedSourcing = (
  job: JobApi,
  options: { isSelfService: boolean; hasPermission: boolean },
): boolean =>
  options.isSelfService && options.hasPermission && canRetryFailedSourcing(job);

/** Another round of a finished search, on a job that's still live. A failed search is retried instead. */
export const canFindMoreCandidates = (job: JobApi): boolean =>
  job.sourcingState === 'Finished' &&
  job.state !== 'OnHold' &&
  job.state !== 'Hired' &&
  job.state !== 'Closed';

/**
 * On a self-service plan the customer runs their own rounds, within the allowance (finlay-api SourcingService:
 * starting the search, and editing the job or continuing sourcing). On a managed plan their recruiter runs them.
 */
export const canUserFindMoreCandidates = (
  job: JobApi,
  options: { isSelfService: boolean; hasPermission: boolean },
): boolean =>
  options.isSelfService && options.hasPermission && canFindMoreCandidates(job);
